Promise.all([import('scripts/marmalade/classes/image-normalizer')]).then(_ref => {
  let [moduleImageNormalizerController] = _ref;
  // Grab the modules
  const ImageNormalizer = new moduleImageNormalizerController.default();

  // Watch for new images that need to be normalized
  DomObserver.observe('img.js-normalize', images => {
    // Add all the images to the ImageNormalizer
    ImageNormalizer.add(images);
  });
}).catch(error => {
  // Handle any errors that occur during import
  console.error('An error occurred while loading the modules:', error);
});